import styled from 'styled-components';

export const ListContainer = styled.div`
  margin-top: 1rem;
  max-width: 100%;
  max-height: 100%;
  overflow-y: scroll;
  overflow-x: scroll;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ListRow = styled.div`
  cursor: pointer;
  background: var(--black-400);
  border-radius: 0.6rem;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem;
  width: fit-content;
`

export const ListRowData = styled.div`
  flex-grow: 1;
  display: flex;
  height: 4rem;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 15rem;
  flex-direction: column;
  gap: 0.4rem;

  &.address {
    width: 60rem;
  }

  p {
    &:first-of-type {
      color: #aca9a9;
    }

    &:last-of-type {
      font-weight: bold;
    }

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 15rem;

    &.address {
      width: 60rem;
    }
  }

  button {
    width: 10rem;
  }
`